import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import {
    configureStore as configureReduxStore,
    EnhancedStore,
    ThunkDispatch,
    UnknownAction,
} from '@reduxjs/toolkit'

import { Reducers, reducers } from './redux/reducers'

export type TypedDispatch = ThunkDispatch<Reducers, unknown, UnknownAction>
export type ReducerGetter = () => Reducers

export const useTypedDispatch = (): TypedDispatch => useDispatch<TypedDispatch>()
export const useTypedSelector: TypedUseSelectorHook<Reducers> = useSelector

export const configureStore = async (preloadedState: Partial<Reducers> = {}): Promise<EnhancedStore<Reducers>> => configureReduxStore({
    reducer: reducers,
    preloadedState,
    // RTK's dev-only serializability and immutability checks are left off to keep the behavior of the previous plain
    // Redux store (some state, like dates, isn't serializable).
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
    }),
    devTools: process.env.NODE_ENV !== 'production' && process.env.REACT_APP_APP_ENV !== 'production',
})
